const removeItem = (array, item) => {
  let index = array.findIndex((idx) => idx === item);
  if (index !== undefined) array.splice(index, 1);
};

export default removeItem;
